




import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class NoImage extends Vue {
  @Prop({ type: String, default: "" }) foo!: string;
}
export default NoImage;
